import logo from './logo.png';
import './App.css';
import {useEffect, useState} from "react";

const LAMBDA_URL = 'https://mtle6uxmc4uxpgb44pxskqswky0biobh.lambda-url.eu-north-1.on.aws';

const DEBUG = false;

function getISOWeek(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 3 - (d.getDay() + 6) % 7);
  const week1 = new Date(d.getFullYear(), 0, 4);
  return 1 + Math.round(((d.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}

function urgency(daysUntilFriday) {
  const t = (6 - Math.min(daysUntilFriday, 6)) / 6; // 0 = calmest, 1 = Friday
  const text = Math.round(80 + 175 * t);
  return {
    headerStyle: {},
    textStyle: {color: `rgb(${text}, ${text}, ${text})`},
  };
}

function App() {

  const [daysUntilFriday, setDaysUntilFriday] = useState(0);
  const [quote, setQuote] = useState('');
  const [offset, setOffset] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [loading, setLoading] = useState(true);
  const [debugDays, setDebugDays] = useState(6);

  useEffect(() => {
    if (!DEBUG) return;
    const handleKey = (e) => {
      if (e.key === 'n') setDebugDays(prev => prev === 0 ? 6 : prev - 1);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  const fetchData = (currentOffset) => {
    fetch(`${LAMBDA_URL}?offset=${currentOffset}`)
      .then(response => response.json())
      .then(data => {
        setDaysUntilFriday(data.daysUntilFriday);
        setQuote(data.quote);
        setCurrentTime(data.currentTime);
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
      });
  };

  // Initial load
  useEffect(() => {
    fetchData(0);
  }, []);

  // Poll only when daysUntilFriday === 0
  useEffect(() => {
    // If it is not Friday, do not start polling
    if (daysUntilFriday !== 0) {
      return; // no interval created
    }

    const intervalId = setInterval(() => {
      fetchData(offset);
    }, 6000);

    // Cleanup when component unmounts or when daysUntilFriday changes
    return () => clearInterval(intervalId);
  }, [daysUntilFriday, offset]);

  const cycleQuote = () => {
    const nextOffset = offset + 1;
    setOffset(nextOffset);
    fetchData(nextOffset);
  };

  const displayDays = DEBUG ? debugDays : daysUntilFriday;
  const localMidnight = new Date(currentTime * 1000);
  localMidnight.setHours(24, 0, 0, 0);
  const hoursUntilFriday = Math.ceil((localMidnight - currentTime * 1000) / 3600000);
  const displayHours = DEBUG && debugDays === 1 ? 1 : hoursUntilFriday;

  const {headerStyle, textStyle} = urgency(displayDays);

  useEffect(() => {
    if (loading) return;
    if (displayDays === 0) {
      document.title = 'FREDAG!';
    } else if (displayDays === 1) {
      document.title = `${displayHours} ${displayHours === 1 ? 'timme' : 'timmar'} kvar`;
    } else {
      document.title = `${displayDays} dagar kvar`;
    }
  }, [loading, displayDays, displayHours]);

  return (
    <div className="App">
      <header className="App-header" style={headerStyle}>

        {!loading && <p className="Vecka">Vecka {getISOWeek(new Date())}</p>}
        {loading ? <div/> : displayDays === 0 ?
          <div className="Friday">
            <img src={logo} className="App-logo" alt="logo"/>
            <a
              className="Spotify-link"
              href="https://open.spotify.com/artist/4KXp3xtaz1wWXnu5u34eVX"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" aria-hidden="true">
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
              </svg>
              Klicka, lyssna, njut p&aring; Spotify
            </a>
            <p key={quote} id="quote" className="Quote" onClick={cycleQuote} style={{cursor: 'pointer'}}>
              "{quote}"
            </p>
          </div>
          : displayDays === 1 ?
            <div>
              <p className="Countdown" style={textStyle}>{displayHours} {displayHours === 1 ? 'timme' : 'timmar'} kvar...</p>
              <p className="Tagline">{displayHours <= 6 ? 'snart är det fredag!' : 'imorgon är det fredag!'}</p>
            </div>
            :
            <div>
              <p className="Countdown" style={textStyle}>{displayDays} dagar kvar...</p>
            </div>}
      </header>
    </div>
  );
}

export default App;
